module.exports = __webpack_public_path__ + "img/api.9aa0b1f4.svg";